import React, {useEffect, useState} from 'react';
import {Can} from "../../../ability-context";
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {
    createCommentLike,
    createSubCommentLike, deleteCommentLike,
    deleteSubCommentLike
} from "../../../api/public-voissa/likes";
import {toastError} from "../../../libs/toast";
import {LIKE} from "../../../const/toasts";
import CtaCannot from "../CtaCannot";
import {COMMENT_KEY} from "../../../api/public-voissa/comments";

const LikeComment = ({
         isLiked = false,
         value = 0,
         likeType = null,
         parentId = null,
         commentId = null,
         subCommentId = null
     }) =>{

    const queryClient = useQueryClient();
    const [toggleLike, setToggleLike] = useState(isLiked);
    const [count, setCount] = useState(value);

    let functionLikeMap = {
        create : () => !!subCommentId ? createSubCommentLike(likeType, parentId, commentId, subCommentId) : createCommentLike(likeType, parentId, commentId),
        delete : () => !!subCommentId ? deleteSubCommentLike(likeType, parentId, commentId, subCommentId) : deleteCommentLike(likeType, parentId, commentId),
    }

    const {
        mutate : mutateLike,
    } = useMutation(() => toggleLike ? functionLikeMap.create() : functionLikeMap.delete(),{
        onSuccess : async (data, variables) =>{
            //await queryClient.invalidateQueries([COMMENTS_KEY, parentId]);
            await queryClient.invalidateQueries([COMMENT_KEY, parentId]);
            /*const previousValues = queryClient.getQueryData([COMMENTS_KEY, parentId]);
            if(previousValues){
                let newPagesArray = previousValues?.pages.map((page) => {
                        page.data = page.data.map((item) => {
                            if(item._id.toString() === data._id.toString()){
                                item = {...item, isLiked : variables.isLiked};
                            }
                            return item;
                        });
                        return page;
                    }
                ) ?? [];

                queryClient.setQueryData([COMMENTS_KEY, parentId], oldData => ({
                    pages: newPagesArray,
                    pageParams: oldData.pageParams,
                }));
            }*/

        },
        onError: () =>{
            toastError(!toggleLike ? LIKE.ERROR.CREATE : LIKE.ERROR.DELETE);
            setToggleLike(!toggleLike);
            setCount(value)
        }
    });

    function handleToggleLike() {
        mutateLike();
        setToggleLike(!toggleLike);
        setCount(!toggleLike ? count +1 : count -1);
    }

    useEffect(() => {
        setToggleLike(isLiked);
        setCount(value);
    }, [isLiked, value]);

    return(
        <Can action="create" subject="Like" passThrough>
            {can => {
                return can ? (
                    <div className={`likes ${toggleLike && 'active'}`} onClick={() => handleToggleLike()}>
                        J'aime{count > 1 ? 's' : ""} ({count})
                    </div>
                ) : (
                    <div className={`likes ${toggleLike && 'active'}`}>
                        <CtaCannot action={"like"} isModal={true} >
                                J'aime{count > 1 ? 's' : ""} ({count})
                        </CtaCannot>
                    </div>
                )}}
        </Can>
    )
};

export default LikeComment;